namespace TabAurous.Purchase {
    export namespace ApprovalInAPIService {
        export const baseUrl = 'Sales/ApprovalIn';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/ApprovalIn/Create",
            Update = "Sales/ApprovalIn/Update",
            Delete = "Sales/ApprovalIn/Delete"
        }

        [
            'Create', 
            'Update', 
            'Delete'
        ].forEach(x => {
            (<any>ApprovalInAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
